






















































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import AppModal from '@/components/AppModal.vue';
import {mapState} from 'vuex';
import DoubleDatePicker from '@/components/DoubleDatePicker.vue';
import ToastMessage from '@/components/ToastMessage.vue';
import IconStopSale from '@/components/icons/IconStopSale.vue';
import moment from 'moment';
import BulkUpdateRequest from '@/models/BulkUpdateRequest';
import TrackingUtils from '@/utils/tracking';
import { inputIsNumber } from '@/utils/utils';
import PriceInputWithCurrency from '@/components/PriceInputWithCurrency.vue';

const dayList = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

@Component({
  components: { AppModal, DoubleDatePicker, ToastMessage, PriceInputWithCurrency, IconStopSale },
  computed: mapState(['dashboard', 'modals', 'partner']),
})
export default class ModalBulkUpdate extends Vue {
  @Prop() public readonly show!: boolean;
  public dashboard!: any;
  public partner!: any;
  public roomStatus: string = '';
  public roomAvailable: any = '';
  public roomPrice: string|number = '';
  public allDays: boolean = true;
  public roomStatusList: any[] = [
    {label: 'bulkUpdate.open', value: 'I'},
    {label: 'bulkUpdate.stopSale', value: 'U'},
  ];
  public cleanForm: boolean = true;
  public isLoading: boolean = false;
  public errorCode: string = '';
  public hasSubmited: boolean = false;
  public roomPriceError: boolean = true;
  public days: any = dayList.map((day: string, index: number) => ({
    label: moment().day(index + 1).format('dd'),
    value: true,
    name: day,
  }));
  public dateRange: any = {
    start: null,
    end: null,
  };

  get pricingEnabled() {
    return typeof(this.dashboard.selectedRoom) !== 'undefined' ? this.dashboard.selectedRoom.pricingEnabled : false;
  }

  get currencyCode() {
    return typeof(this.dashboard.selectedRoom) !== 'undefined' ? this.dashboard.selectedRoom.currencyCode : 'EUR';
  }

  get daysOfWeek() {
    return this.days.filter((item: any) => (item.value)).map((item: any) => (item.name));
  }

  get errors() {
    const errors: any = {};
    const roomStatusError = !this.roomStatus;
    const roomAvailableError = this.roomAvailable > 99 || this.roomAvailable < 0 || this.roomAvailable === '';
    const roomPriceError = this.pricingEnabled && this.roomPriceError;
    errors.dateRange =
      !this.dateRange
      || !this.dateRange.start
      || !this.dateRange.end
      ? 'Please select a date range'
      : '';
    errors.daysOfWeek = !this.daysOfWeek.length ? 'bulkUpdate.errors.selectDaysOfTheWeek' : '';
    if (this.pricingEnabled) {
      errors.typeOfAvailability = roomStatusError && roomAvailableError && roomPriceError
            ? 'bulkUpdate.errors.selectAvailabilityType'
            : '';
    } else {
      errors.typeOfAvailability = roomStatusError && roomAvailableError
            ? 'bulkUpdate.errors.selectAvailabilityType'
            : '';
    }
    return errors;
  }

  get formValid() {
    let valid = true;
    Object.values(this.errors).forEach((error: any) => {
      if (error) { valid = false; }
    });
    return valid;
  }

  get calendarMaxRange(): number {
    const nMonths = Number(process.env.VUE_APP_BULK_UPDATE_MAX_RANGE_MONTHS) || 6;
    const endDate = moment().add(nMonths, 'months');
    return endDate.diff(moment(), 'days');
  }

  /**
   * When the modal is closed, we display the updated range on the dashboard.
   * If the range has more days than can be displayed, this calculates the end date of the dashboard range.
   */
  get dashboardEndDateAfterClosing() {
    return moment(this.dateRange.end).diff(moment(this.dateRange.start), 'days') < this.$store.getters.maxDays
      ? this.dateRange.end
      : moment(this.dateRange.start).add(this.$store.getters.maxDays, 'days').format('YYYY-MM-DD');
  }

  public updateRoomPriceError(err: boolean) {
    this.roomPriceError = err;
  }

  public toggleBulkUpdateModal() {
    if (this.isLoading) {
      return;
    }
    this.resetForm();
    this.$store.dispatch('toggleModal', 'bulkUpdate');
    if (!this.hasSubmited) {
      this.$gtm.trackEvent({
        event: 'availabilityPageBulkUpdateCancel',
      });
    }
    this.hasSubmited = false;
  }

  public selectAllDays() {
    this.days.forEach((day: any) => {
      day.value = this.allDays;
    });
  }

  public toggleSingleDay(day: boolean) {
    if (!day) {
      this.allDays = false;
    } else if (this.days.map((item: any) => item.value).reduce((allDays: any, currDay: any) => {
      return allDays && currDay;
    })) {
      this.allDays = true;
    }
  }

  public resetForm() {
    this.cleanForm = true;
    this.dateRange = {
      start: this.dashboard.dateRange.start,
      end: this.dashboard.dateRange.end,
    };
    this.roomStatus = '';
    this.roomAvailable = '';
    this.roomPrice = '';
    this.roomPriceError = true;
    this.allDays = true;
    this.selectAllDays();
  }

  public trimAvailability(event: KeyboardEvent) {
    if ((this.roomAvailable.toString().length > 2) || !inputIsNumber(event)) {
      this.roomAvailable = this.roomAvailable.toString().slice(0, -1);
    }
  }

  public dismissToast() {
    this.cleanForm = true;
  }

  public async submitForm() {
    this.cleanForm = false;
    this.errorCode = '';
    if (this.formValid) {
      const payload: BulkUpdateRequest = {
        roomId: this.dashboard.selectedRoom.id,
        startDate: this.dateRange.start,
        endDate: this.dateRange.end,
        daysOfWeek: this.daysOfWeek.join(','),
      };
      if (this.roomStatus) { payload.availabilityType = this.roomStatus; }
      if (this.roomAvailable || this.roomAvailable === 0) { payload.availabilityQty = this.roomAvailable; }
      if (this.roomPrice !== '') {
        payload.amount = Math.round(Number(this.roomPrice.toString().replace(',', '.')) * 100);
      }
      try {
        this.isLoading = true;
        const promises = [];
        const roomInfo = {
          startDate: payload.startDate,
          endDate: payload.endDate,
          roomId: payload.roomId,
          pricingEnabled: this.dashboard.selectedRoom.pricingEnabled,
        };
        const priceInfo = await this.$store.dispatch('getPricesFromRoom', roomInfo);
        if (!!this.roomStatus || !!this.roomAvailable) {
          promises.push(this.$store.dispatch('bulkUpdate', payload));
        }
        if (payload.amount === 0 || (payload.amount as number) >= 100 ) {
          promises.push(this.$store.dispatch('bulkPriceUpdate', payload));
        }
        Promise.all(promises).then(async () => {
          const prevAmount = priceInfo.reduce((sum: any, room: any) => (sum + Number(room.amount)), 0);
          const newAmount = payload.amount ? payload.amount * priceInfo.length : 0;
          const percentage = TrackingUtils.getPercentage(prevAmount, newAmount);
          this.isLoading = false;
          this.hasSubmited = true;

          this.$store.dispatch('getDashboardData', {
            start: this.dateRange.start,
            end: this.dashboardEndDateAfterClosing,
          });

          this.toggleBulkUpdateModal();
          this.$store.dispatch('addToast', {
            type: 'success',
            message: 'messages.success.bulkUpdateApplied',
            timeout: 3,
          });
          this.$gtm.trackEvent({
            event: 'availabilityPageBulkUpdateSave',
            details: {
              partnerId: this.partner.id,
              start_date: moment(payload.startDate).format('DD-MM-YYYY'),
              end_date: moment(payload.endDate).format('DD-MM-YYYY'),
              days_of_the_week: TrackingUtils.getDaysOfWeek(this.daysOfWeek),
              room_status: !payload.availabilityType ? null : payload.availabilityType === 'I' ? 'open' : 'stop sale',
              rooms_available: !payload.availabilityQty
                ? null
                : TrackingUtils.getAvailabilityRange(payload.availabilityQty),
              value: !payload.amount ? null : payload.amount / 100,
              additionalNight: !payload.amount
                ? null : newAmount - prevAmount > 0
                  ? 'increase' : 'decrease',
              incrementalValue: !payload.amount ? null : `${percentage}%`,
              incrementalValueRange: !payload.amount ? null : TrackingUtils.getPercentageRange(percentage),
            },
          });
        });
      } catch (e) {
        this.errorCode = '310';
        this.isLoading = false;
      }
    } else {
      this.$nextTick(() => {
        const firstErrorElement = document.getElementsByClassName('box error');
        if (firstErrorElement.length) {
          firstErrorElement[0].scrollIntoView({behavior: 'smooth'});
        }
      });
    }
  }

  public mounted() {
    window.onbeforeunload = () => {
      if (this.isLoading) {
        // the message will be overwritten by browser
        return 'Are you sure you want to leave?';
      }
    };
  }

  @Watch('dashboard.dateRange', {immediate: true})
  private initDateRange({start, end}: any) {
    this.dateRange = { start, end };
  }

  @Watch('partner.lang', {immediate: true})
  private onLangChange(value: string) {
    moment.locale(value);
    this.days.forEach((day: any, index: number) => {
      day.label = moment().day(index + 1).format('dd');
    });
  }
}
